import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { defaultOnClusterClickHandler } from "@googlemaps/markerclusterer/";

// Replicated jQuery .offset()
function getElementOffset(element) {
    if (!element.getClientRects().length) {
        return { top: 0, left: 0 };
    }

    const rect = element.getBoundingClientRect();
    const doc = element.ownerDocument;
    const docElem = doc.documentElement;
    const win = doc.defaultView;

    return {
        top: rect.top + win.scrollY - docElem.clientTop,
        left: rect.left + win.scrollX - docElem.clientLeft
    };
}

function applyStyles(element, styleObject) {
    for ( let key in styleObject ) {
        element.style[key] = styleObject[key];
    }
}

function extend(obj1, obj2) {
    for ( let key in obj2 ) {
        obj1[key] = obj2[key];
    }

    return obj1;
}

window.addEventListener('load', () => {
    // sort all home designs into memory
    const displayMapContainer = document.getElementById('display-homes-map');
    const contactMapContainers = document.querySelectorAll('[data-google-map-container]');

    const googleMapsLoader = new Loader({
        apiKey: window.googleMapsApiKey,
        version: "weekly"
    });

    const googleMapsOpts = (google, centerPos = null) => {
        return {
            mapId: window.googleMapsMapId,
            zoom: 10,
            center: centerPos ? centerPos : new google.maps.LatLng(-32.039, 115.843),
            mapTypeControl: false,
            panControl: false,
            scaleControl: false,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            }
        };
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                entry.target.classList.add("drop");
                intersectionObserver.unobserve(entry.target);
            }
        }
    });

    const animateMarker = function (content) {
        content.style.opacity = "0";
        content.addEventListener("animationend", (event) => {
            content.classList.remove("drop");
            content.style.opacity = "1";
        });
        const time = 0.5;
        content.style.setProperty("--delay-time", time + "s");
        intersectionObserver.observe(content);
    };


    let googleMaps = null;
    let activeInfoWindow = null;
    let bouncingMarker = null;
    let markerWasClicked = false;
    let baseTop = null;

    const activateMarker = (marker, bounce) => {
        if (bounce) {
            if (bouncingMarker && bouncingMarker !== marker) {
                bouncingMarker.classList.remove('bounce');
            }

            if (marker.classList.contains('bounce')) {
                marker.classList.remove('bounce');
                bouncingMarker = null;
            }
            else {
                marker.classList.add('bounce');
                bouncingMarker = marker;
                setTimeout(function () {
                    if (bouncingMarker) {
                        bouncingMarker.classList.remove('bounce');
                    }
                }, 5000);
            }
        }
    };

    const loadDisplayHomesMap = async function (container) {
        const libraries = await Promise.all([
            googleMapsLoader.importLibrary('core'),
            googleMapsLoader.importLibrary('maps'),
            googleMapsLoader.importLibrary('marker'),
        ]);

        const mapMarkers = [];
        const markerBounds = new google.maps.LatLngBounds();

        document.querySelectorAll('.display-homes-card').forEach((markerElement) => {
            const lat = parseFloat(markerElement.getAttribute('data-latitude'));
            const lng = parseFloat(markerElement.getAttribute('data-longitude'));

            markerBounds.extend(new google.maps.LatLng(lat, lng));
        });

        googleMaps = new google.maps.Map(container, googleMapsOpts(google, markerBounds.getCenter()));
        googleMaps.fitBounds(markerBounds);

        document.querySelectorAll('.display-homes-card').forEach((markerElement) => {
            const lat = parseFloat(markerElement.getAttribute('data-latitude'));
            const lng = parseFloat(markerElement.getAttribute('data-longitude'));
            const markerPageUrl = markerElement.getAttribute('data-page-url');

            const pos = new google.maps.LatLng(lat, lng);

            const title = markerElement.getAttribute('data-title');
            const content = document.createElement("div");
            content.classList.add("property");
            content.innerHTML = `
                <div class="icon">
                    <img src="/build/homegroup/svg/icon-map-marker.svg" style="width: 36px; height: 48px;" alt="${title}"/>
                </div>
            `;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: pos,
                map: googleMaps,
                title: title,
                content: content
            });

            animateMarker(content);

            const popupElement = document.createElement('div');
            popupElement.appendChild(document.getElementById('map-marker-template').cloneNode(true).content);
            popupElement.querySelector(`[data-detail="directions-url"]`).href = `https://www.google.com/maps/dir//${lat},${lng}/@${lat},${lng},19z'`;
            if (markerPageUrl) {
                popupElement.querySelector(`[data-detail="page-url"]`).href = markerPageUrl;
            }

            let popupData = {
                'title': markerElement.getAttribute('data-title'),
                'estate': markerElement.getAttribute('data-estate'),
                'full-address': markerElement.getAttribute('data-address'),
                'bedrooms': markerElement.getAttribute('data-bedrooms'),
                'bathrooms': markerElement.getAttribute('data-bathrooms'),
                'frontage': markerElement.getAttribute('data-frontage'),
                'carports': markerElement.getAttribute('data-carspaces'),
                'storeys': markerElement.getAttribute('data-storeys'),
            }

            for ( let key in popupData ) {
                const element = popupElement.querySelector(`[data-detail="${key}"]`);
                if (element) {
                    if (key === 'storeys' && popupData[key] === '1') {
                        element.innerText = 'Single Storey';
                    }
                    else if (key === 'storeys' && popupData[key] === '2') {
                        element.innerText = 'Double Storey';
                    }
                    else {
                        element.innerText = popupData[key];
                    }
                }
            }

            mapMarkers.push(marker);

            google.maps.event.addListener(marker, 'click', function () {
                if (activeInfoWindow) {
                    activeInfoWindow.close();
                }

                const infoWindow = new google.maps.InfoWindow({
                    content: popupElement.innerHTML
                });

                activateMarker(marker.content, true, google);
                markerWasClicked = true;

                infoWindow.open(googleMaps, marker);
                activeInfoWindow = infoWindow;

                setTimeout(function () {
                    // apply styles to google map infowindow
                    const popupWidget = document.querySelector('.gm-style-iw-t');
                    const popupWidgetContainer = document.querySelector('.gm-style-iw');
                    const closePopupButton = document.querySelector('.gm-ui-hover-effect');

                    popupWidget?.classList?.add('gmap-single-popup-widget');
                    popupWidgetContainer?.classList?.add('gmap-single-popup-widget-container');
                    closePopupButton?.classList?.add('gmap-close-widget-btn');
                }, 1);
            });

            google.maps.event.addListener(
                marker,
                'mouseover',
                _debounce(function (event) {
                    event.stop();

                    if (!markerWasClicked) {
                        activateMarker(marker.content, false, google);
                    }
                }, 320)
            );
        });

        new MarkerClusterer({
            map: googleMaps,
            markers: mapMarkers,
            renderer: {
                render: ({ count, position }) => {
                    const clustererMarkerContent = document.createElement("div");
                    clustererMarkerContent.classList.add("property");
                    clustererMarkerContent.style.zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
                    clustererMarkerContent.innerHTML = `
                        <div class="icon cluster-marker-icon">
                            <img src="/build/homegroup/svg/icon-map-marker-cluster.svg" style="width: 70px; height: 56px;" alt=""/>
                            <span class="cluster-marker-icon-label">${String(count)}</span>
                        </div>
                    `;
                    return new google.maps.marker.AdvancedMarkerElement({
                        position,
                        content: clustererMarkerContent
                    });
                }
            },
            onClusterClick: (event, cluster, map) => {
                defaultOnClusterClickHandler(event, cluster, map);

                setTimeout(() => {
                    if (activeInfoWindow) {
                        activeInfoWindow.close();
                    }
                }, 100);
            }
        });
    };

    if (displayMapContainer) {
        loadDisplayHomesMap(displayMapContainer);

        const scrollFunc = () => {
            const mapContainer = document.querySelector('.map-container');
            const cardWrapper = document.querySelector('.card-wrapper');

            const siteHeaderHeight = document.querySelector('#siteHeader').clientTop + document.querySelector('#siteHeader').clientHeight;

            const mapTop = getElementOffset(mapContainer).top - siteHeaderHeight;
            const isPositionFixed = mapContainer.style.position === 'fixed';

            const csOffsets = getElementOffset(cardWrapper);
            const csHeight = cardWrapper.getBoundingClientRect().height;

            let belowBottomDiv = window.scrollY >= csOffsets.top + csHeight - window.innerHeight;
            let aboveTopDiv = baseTop !== null && window.scrollY < baseTop;

            if (window.scrollY > mapTop && !isPositionFixed && !belowBottomDiv) {
                applyStyles(mapContainer, {
                    position: 'fixed',
                    top: `${siteHeaderHeight}px`,
                    height: '100vh',
                    right: 'unset',
                    left: 'unset',
                });

                if (baseTop === null) {
                    baseTop = mapTop;
                }
            }
            else if (window.scrollY < mapTop && !isPositionFixed && !belowBottomDiv) {
                applyStyles(mapContainer, { position: 'absolute', top: 0, height: '100vh', right: 0, left: 0 });

                if (baseTop === null) {
                    baseTop = mapTop;
                }

            }
            else if (isPositionFixed) {
                if (aboveTopDiv) {
                    applyStyles(mapContainer, {
                        position: 'absolute',
                        top: 0,
                        height: '100vh',
                        bottom: 'auto',
                        right: 0,
                        left: 0
                    });
                }
                else if (belowBottomDiv) {
                    applyStyles(mapContainer, {
                        position: 'absolute',
                        top: 'auto',
                        height: 'unset',
                        bottom: 0,
                        right: 0,
                        left: 0
                    });
                }
            }
            else if (!isPositionFixed) {
                if (aboveTopDiv) {
                    applyStyles(mapContainer, {
                        position: 'absolute',
                        top: 'auto',
                        height: '100vh',
                        bottom: 'auto',
                        right: 0,
                        left: 0
                    });
                }
            }
        }

        window.addEventListener('scroll', scrollFunc);

        setTimeout(() => {
            scrollFunc();
        }, 10);

        const toggleMapButton = document.querySelector('button[name="toggleMap"]');
        toggleMapButton?.addEventListener('click', () => {
            const cardWrapper = document.querySelector('.card-wrapper');
            const mapWrapper = document.querySelector('.map-wrapper');

            if (cardWrapper && mapWrapper) {
                mapWrapper.classList.toggle('!hidden');
                const isHidden = mapWrapper.classList.contains('!hidden');

                if (isHidden) {
                    cardWrapper.classList.add('lg:grid-cols-3', 'lg:col-span-3')
                }
                else {
                    cardWrapper.classList.remove('lg:grid-cols-3', 'lg:col-span-3')
                }

                toggleMapButton.innerText = `${isHidden ? 'Show' : 'Hide'} Map`;
            }
        })
    }

    const loadContactUsMap = async function (contactMapContainer) {
        const libraries = await Promise.all([
            googleMapsLoader.importLibrary('core'),
            googleMapsLoader.importLibrary('maps'),
            googleMapsLoader.importLibrary('marker'),
        ]);

        const lat = parseFloat(contactMapContainer.getAttribute('data-latitude'));
        const lng = parseFloat(contactMapContainer.getAttribute('data-longitude'));
        const pos = new google.maps.LatLng(lat, lng);

        googleMaps = new google.maps.Map(contactMapContainer, googleMapsOpts(google, pos));

        const title = contactMapContainer.getAttribute('data-title');

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: pos,
            map: googleMaps,
            title: title,
        });

        animateMarker(marker.content);
    }

    if (contactMapContainers.length) {
        const contactMapPanel = document.querySelector('.contact-map-panel');

        if (contactMapPanel) {
            const contactMaps = contactMapPanel.querySelectorAll('[data-map-for-division]');
            const contactMapSwitcherButtons = contactMapPanel.querySelectorAll('button[data-show-map]');

            contactMapPanel.addEventListener('click', (event) => {
                const clickedEventItem = event.target;

                if (clickedEventItem.hasAttribute('data-show-map')) {
                    const comparisonValue = clickedEventItem.dataset.showMap;

                    contactMapSwitcherButtons.forEach((mapToggle) => {
                        mapToggle.dataset.active = (mapToggle.dataset.showMap === comparisonValue).toString();
                    });

                    contactMaps.forEach((contactMap) => {
                        contactMap.dataset.active = (contactMap.dataset.mapForDivision === comparisonValue).toString();
                    });
                }
            });
        }

        contactMapContainers.forEach((contactMapContainer) => {
            loadContactUsMap(contactMapContainer);
        });
    }
});